<template>
  <section>
    <top-menu/>

    <ModalDefault modal-title="Editar espelho personalizado" modal-id="changeMirrorPoint">
      <div v-if="mirrorSelected" class="modal-change-custom-mirror">
        <p>Nome: <span>{{ mirrorSelected.name }}</span></p>
        <div v-for="(value, index) in mirrorSelected.properties" :key="index">
          <input-checkbox col="6" :label="value.displayName" :is-checked="value.enabled"
                          @valueCheckbox="val => value.enabled = val"/>
        </div>
      </div>
      <btn-custom which-side="right" label="Salvar" :have-loading="true" :loading="loadingUpdate"
                  :disabled="loadingUpdate" @emit-click="updateCustomMirror()"/>
    </ModalDefault>

    <section>
      <page-header :headerName="'Espelhos de ponto personalizados'" :showBtn="true" :btnName="'Voltar'"
                   :btnRoute="'/detalhes-da-empresa/' + this.$route.params.companyId + '/' + this.$route.params.context"
                   :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <full-loading v-if="loading"/>

            <div v-if="!loading && !dataMirrors.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum espelho cadastrado.</p>
              </div>
            </div>

            <div v-if="!loading && dataMirrors.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="portlet light">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de espelhos personalizados ({{
                        dataMirrors.length
                      }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> Nome do espelho</th>
                        <th> Ações</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataMirrors">
                        <th>{{ c.name }}</th>
                        <td>
                          <a v-on:click="openModalEdit(c)" class="edit">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                            Editar
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import ModalDefault from "../../components/modals/modalDefault.vue";
import InputText from "../../components/inputs/inputText.vue";
import InputCheckbox from "../../components/inputs/inputCheckbox.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {GET_ALL_CUSTOM_MIRRORS, UPDATE_CUSTOM_MIRROR} from "../../../../urlConfig";
import swal from "sweetalert";

export default {
  name: "list-custom-mirror-point",
  components: {
    BtnCustom,
    InputCheckbox,
    InputText,
    ModalDefault,
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      companyId: this.$route.params.companyId,
      context: this.$route.params.context,
      loading: false,
      loadingUpdate: false,
      dataMirrors: [],
      mirrorSelected: null,
    }
  },
  methods: {
    openModalEdit(value) {
      this.mirrorSelected = value;
      $("#changeMirrorPoint").modal();
    },
    getAllCustomMirrors() {
      this.loading = true;
      REQUEST_SERVICE.requestContext('GET', GET_ALL_CUSTOM_MIRRORS + this.companyId, this.context).then((response) => {
        UTIL_SERVICE.console('GET ALL_CUSTOM_MIRRORS', response.data);
        this.dataMirrors = response.data;
        this.loading = false;
      }).catch((reason) => {
        this.loading = false;
        swal("Aviso", reason.response.data, "error");
      })
    },
    updateCustomMirror() {
      this.loadingUpdate = true;
      REQUEST_SERVICE.requestContext('PUT', UPDATE_CUSTOM_MIRROR, this.context, this.mirrorSelected).then((response) => {
        UTIL_SERVICE.console('PUT UPDATE_CUSTOM_MIRROR', response.data);
        this.loadingUpdate = false;
        $("#changeMirrorPoint").modal('hide');
        swal("Sucesso!", `O espelho ${this.mirrorSelected.name} foi atualizado.`, "success");
        this.mirrorSelected = null;
        this.getAllCustomMirrors();
      }).catch((reason) => {
        this.loadingUpdate = false;
        swal("Aviso", reason.response.data, "error");
      })
    },
  },
  beforeMount() {
    this.getAllCustomMirrors();
  },
  mounted() {
    $(`#changeMirrorPoint`).on('hidden.bs.modal', () => {
      this.mirrorSelected = null;
    });
  }
}
</script>

<style lang="scss">
.edit {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none !important;
  font-weight: 600;
}

.modal-change-custom-mirror {
  margin: 20px 0;

  p {
    margin-left: 15px;
    font-size: 16px;
    font-weight: 600;

    span {
      font-weight: 400;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/companyDetail/listCustomMirrorPoint.vue